import RestClientService from "@/core/services/restClient.service";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import { DASHBOARD_API_PATH } from "../constants";
import { IDashboardState } from "@/core/interfaces/dashboard.interface";

class DashboardServices {
  private restClient: RestClientService;

  constructor() {
    this.restClient = new RestClientService();
  }

  public getInsights(
    value: number,
    aggregated_by: string,
  ): Promise<ICoreResponse<IDashboardState>> {
    return this.restClient.get(
      DASHBOARD_API_PATH.GET_INSIGHTS +
        `?value=${value}&aggregated_by=${aggregated_by}`,
    );
  }
  public getDailyFlightIssuance(
    date: string | null,
  ): Promise<ICoreResponse<IDashboardState>> {
    return this.restClient.get(DASHBOARD_API_PATH.GET_FLIGHT_ISSUANCE_DATA, {
      date,
    });
  }
  public getDailyHotelIssuance(
    date: string | null,
  ): Promise<ICoreResponse<IDashboardState>> {
    return this.restClient.get(DASHBOARD_API_PATH.GET_HOTEL_ISSUANCE_DATA, {
      date,
    });
  }
  public getExpirySoon(): Promise<ICoreResponse> {
    return this.restClient.get(DASHBOARD_API_PATH.GET_EXPIRY);
  }
}

export default DashboardServices;
